import { getSourcingCompany, Site } from './site-context'

export type Language = 'Swedish' | 'Danish' | 'Norwegian' | 'English' | 'Finnish' | 'Dutch'
export type SiteSelectorUrls = { consumer: string; business: string }

export type UserSettings = {
  language: Language
  showPricesInclVat: boolean
  selectedContactId?: string | null
  personalizationConsent: boolean
}

export const getDefaultLanguage = (site: Site): Language => {
  const sourcingCompany = getSourcingCompany(site)
  switch (sourcingCompany) {
    case 'NO':
      return 'Norwegian'
    case 'DK':
      return 'Danish'
    case 'FI':
      return 'Finnish'
    case 'NL':
      return 'Dutch'
    case 'SE':
    default:
      return 'Swedish'
  }
}

export type TwoLetterISOLanguage = 'en' | 'nb' | 'da' | 'fi' | 'nl' | 'sv'

export const getTwoLetterISOLanguageName = (language: Language): TwoLetterISOLanguage => {
  switch (language) {
    case 'English':
      return 'en'
    case 'Norwegian':
      return 'nb'
    case 'Danish':
      return 'da'
    case 'Finnish':
      return 'fi'
    case 'Dutch':
      return 'nl'
    case 'Swedish':
    default:
      return 'sv'
  }
}

export const CULTURE_CODE = ['en-US', 'nb-NO', 'da-DK', 'fi-FI', 'nl-NL', 'sv-SE']
export type CultureCode = 'en-US' | 'nb-NO' | 'da-DK' | 'fi-FI' | 'nl-NL' | 'sv-SE'

export const getCultureCode = (language: Language): CultureCode => {
  switch (language) {
    case 'English':
      return 'en-US'
    case 'Norwegian':
      return 'nb-NO'
    case 'Danish':
      return 'da-DK'
    case 'Finnish':
      return 'fi-FI'
    case 'Dutch':
      return 'nl-NL'
    case 'Swedish':
      return 'sv-SE'
    default:
      return 'sv-SE'
  }
}

export const getLangFromCultureCode = (cultureCode: CultureCode): Language => {
  switch (cultureCode) {
    case 'en-US':
      return 'English'
    case 'nb-NO':
      return 'Norwegian'
    case 'da-DK':
      return 'Danish'
    case 'fi-FI':
      return 'Finnish'
    case 'nl-NL':
      return 'Dutch'
    case 'sv-SE':
      return 'Swedish'
    default:
      return 'English'
  }
}
